import { combineEpics, ofType } from 'redux-observable'
import { of } from 'rxjs'
import { catchError, filter, map, mergeMap, takeUntil } from 'rxjs/operators'

import { URL_CONST } from 'utils/urlConsts'
import { matchURL } from 'utils/urls'

import { FETCH_SELECTED_COMPANY_DATA_ASYNC } from 'containers/PartnerOptions/constants'
import { addToast } from 'containers/Toasts/actions'

import {
  createSpamAllowListError,
  createSpamAllowListSuccess,
  getSpamAllowListError,
  getSpamAllowListSuccess,
} from './actions'
import {
  CREATE_SPAM_ALLOWLIST_SENDERS_ASYNC,
  FETCH_SPAM_ALLOWLIST_SENDERS_ASYNC,
} from './constants'

const getAllowListEpic = (action$, state$, { api, epicsErrorHandler }) =>
  action$.pipe(
    ofType(FETCH_SELECTED_COMPANY_DATA_ASYNC.SUCCESS, FETCH_SPAM_ALLOWLIST_SENDERS_ASYNC.INITIATE),
    filter((action) => {
      if (action.type === FETCH_SELECTED_COMPANY_DATA_ASYNC.SUCCESS) {
        return matchURL(URL_CONST.settings.community)
      }
      return true
    }),
    mergeMap(() =>
      api.settings.getSpamAllowList(state$.value.partnerOptions.selectedCompany?.value).pipe(
        map((response) => getSpamAllowListSuccess(response)),
        catchError((error) =>
          of(
            addToast({
              type: 'error',
              message: 'Something went wrong. Please try again',
            }),
            epicsErrorHandler(getSpamAllowListError, error)
          )
        ),
        takeUntil(action$.pipe(ofType(FETCH_SPAM_ALLOWLIST_SENDERS_ASYNC.CANCEL)))
      )
    )
  )

const createAllowListEpic = (action$, state$, { api, epicsErrorHandler }) =>
  action$.pipe(
    ofType(CREATE_SPAM_ALLOWLIST_SENDERS_ASYNC.INITIATE),
    mergeMap(() =>
      api.settings
        .createSpamAllowList(
          state$.value.settings.intelligence.spamAllowList.emailsList,
          state$.value.partnerOptions.selectedCompany?.value
        )
        .pipe(
          map((response) => createSpamAllowListSuccess(response)),
          catchError((error) => of(epicsErrorHandler(createSpamAllowListError, error))),
          takeUntil(action$.pipe(ofType(CREATE_SPAM_ALLOWLIST_SENDERS_ASYNC.CANCEL)))
        )
    )
  )

export default combineEpics(getAllowListEpic, createAllowListEpic)
